
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Carte de visite : éléments essentiels et astuces pour la réussir",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Apprenez quoi inclure sur une carte de visite pour marquer les esprits et découvrez des conseils de design pour créer une carte professionnelle et percutante.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Que mettre sur une carte de visite et comment la réussir ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Cet article vous explique comment réussir votre carte de visite professionnelle.",
        },
      ],
    };
  },
};
